import { jsx as _jsx } from "react/jsx-runtime";
const withHideInMobileAppWebView = (Component) => (props) => {
    return window.ReactNativeWebView ? null : _jsx(Component, { ...props });
};
export default withHideInMobileAppWebView;
